/* eslint-disable camelcase */
import { AxiosError } from 'axios';
import useSWRMutation from 'swr/mutation';

import { camelizeKeys, WithStatusT } from '@consumer-frontend/nc-utils';

import {
  apiEndpoints,
  unauthenticatedFetchers,
} from '../lib';

export type ValidateIdentityRequestT = {
  social_security_number: string; // no hyphens
};

export type ValidateIdentityPathT = 'new_customer' | 'returning_customer';

export type RawValidateIdentityResponseT = {
  path: ValidateIdentityPathT | null;
  ssn_apply_eligible: boolean;
  access_token?: string;
  refresh_token?: string;
};

export type ValidateIdentityResponseT = {
  path: ValidateIdentityPathT | null;
  ssnApplyEligible: boolean;
  status: number; // 200 on all success responses
  accessToken?: string;
  refreshToken?: string;
};

export type ValidateIdentityErrorTypeT = 'CACHE_MISS' | 'email_not_verified';

export type ValidateIdentityErrorResponseT = {
  error_type?: ValidateIdentityErrorTypeT;
};

export const useValidateIdentity = () => {
  const {
    error,
    isMutating,
    reset,
    trigger: validateIdentity,
  } = useSWRMutation<
    ValidateIdentityResponseT,
    AxiosError<ValidateIdentityErrorResponseT>,
    string,
    ValidateIdentityRequestT
  >(
    apiEndpoints.apply.validateIdentity,
    async (url, { arg }) => {
      // eslint-disable-next-line max-len
      const data = await unauthenticatedFetchers.post<ValidateIdentityRequestT>(url, { arg }) as WithStatusT<RawValidateIdentityResponseT>;

      const camelizedData = camelizeKeys(data) as ValidateIdentityResponseT;

      return camelizedData;
    },
    { throwOnError: true },
  );

  return {
    error,
    isMutating,
    reset,
    validateIdentity,
  };
};
